<div class="row  align-items-center">
  <div class="col-12">
      <mat-button-toggle-group  class="col-12 row no-padding" #group="matButtonToggleGroup"   [(ngModel)]="isStation">
          <mat-button-toggle  class="col-md-6 col-6  vv"  value="1">
            <mat-icon class="ff" >flag</mat-icon>
              <!-- Desktop -->
              <span class="d-none d-md-inline">
                {{ 'SEARCH.EMPLACEMENTSEARCH' | translate }}
              </span>

              <!-- Mobile -->
              <span class="d-inline d-md-none">
                {{ 'SEARCH.EMPLACEMENTSEARCH1' | translate }}
              </span>
          </mat-button-toggle>
          <mat-button-toggle class="col-md-6 col-6 kk"   value="0">
            <mat-icon >search</mat-icon>
            <span class="d-none d-md-inline" >{{ 'SEARCH.ADRESSESEARCH' | translate }}</span>
            <span class="d-inline d-md-none" >{{ 'SEARCH.EMPLACEMENTSEARCH1' | translate }}</span>
          </mat-button-toggle>
          
        </mat-button-toggle-group>
        <!-- <mat-slide-toggle setAddress=""   (change)="switchMode($event)" [checked]="isStation"></mat-slide-toggle> -->
  </div>

  <div *ngIf=" group.value == 1 ; then stationBlock else addressBlock"></div>
  <ng-template #stationBlock>
    <mat-form-field class="col-sm-12">
        <mat-icon matSuffix>flag</mat-icon>
      <input class="col-sm-12" type="text" placeholder="{{ 'SEARCH.EMPLACEMENT' | translate }}" aria-label="Number" matInput
        [formControl]="myControl" [matAutocomplete]="auto" required>
      <mat-autocomplete (optionSelected)="onStationChanged($event)" #auto="matAutocomplete">
        <mat-option class="col-sm-12" *ngFor="let option of filteredOptions | async" [value]="option.name">
          {{option.name}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </ng-template>
  <ng-template #addressBlock>
    <div class="col-12">
      <AutocompleteComponent (setAddress)="onAddressChange($event)" ></AutocompleteComponent>
    </div>
  </ng-template>


</div>
